import { ChangeDetectorRef, Component, HostListener, OnInit, inject, NgZone } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ApiService } from './services/api.service';
import { StorageService } from './services/storage.service';
import { LoaderService } from './services/loader.service';
import { Subject } from 'rxjs';
import { Router, ActivatedRoute, RouterEvent, NavigationEnd, NavigationStart } from '@angular/router';
export type ExtFlow = 'upload' | 'signature' | 'unknown';
import { SuccessDialogComponent } from 'src/app/shared/components/success-dialog/success-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { LogRocketService } from './services/logrocket.service';
import { ConfigService } from './services/config.service';
import * as Sentry from '@sentry/angular';
import { PermissionService, getMenuScreenIds, getMenuScreenList } from './services/permission.service';
import { SecondScreenService } from './services/second-screen.service';
import { AuthSessionService } from './services/auth-session.service';
import { TesseractEngineService } from './services/tesseract-engine.service';
import { DocumentTypeDetectionService } from './services/document-type-detection.service';
import { take } from 'rxjs/operators';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
// upgrade Angular to 20 Done
export class AppComponent implements OnInit {
  title = 'trial-reg';
  public getScreenWidth: any;
  public getScreenHeight: any;
  public isSplashVisible: boolean = true;

  public SITE_KEY: string = "";
  public SPLASH_TIMEOUT: number = 0;
  private pageTitle: string = "";
  public isLoggedIn: boolean = false;
  public currentUser: any = null;
  public isLoginPage: boolean = false;
  labels: any = null;
  previousUrl: string = undefined;
  currentUrl: string = undefined;
  deviceInfo: any;
  selectedLanguage = '';
  isIndividualUser = false;
  private isExtensionEntry = false;
  waitingForExt = false;
private extensionTimeoutRef: any;
  private readonly forcedLogoutSessionKey = 'forcedLogoutByExtension';
  private readonly forcedLogoutEventKey = 'forcedLogoutEvent';
  private readonly tabId: string;
  private readonly onPageHide = (): void => {
    this.secondScreen.unregisterAppTab(this.tabId);
  };

  constructor(private apiService: ApiService, private titleService: Title, private route: ActivatedRoute,private dialog: MatDialog,
    private storageService: StorageService, private loader: LoaderService, private router: Router, private zone: NgZone,
    private logRocketService: LogRocketService,
    private configService: ConfigService,
    private permissionService: PermissionService,
    private secondScreen: SecondScreenService,
    private authSession: AuthSessionService,
    private tesseractEngine: TesseractEngineService,
    private documentTypeDetection: DocumentTypeDetectionService,
  ) {
    this.tabId = this.getOrCreateTabId();
    const userLang = localStorage.getItem('language');
    this.applyDocumentLanguage(userLang);
    this.getConfig();
    this.getTranslations(userLang);

    //this.currentUrl = this.router.url;
    this.currentUrl = window.location.href;

    if (this.currentUrl.includes("/dashboard/upgrade")) {
      localStorage.setItem('previousURL', "/dashboard/upgrade");
    }
    this.currentUrl = window.location.href;

    const nav = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming;
    const isReload = nav?.type === 'reload';

    if (this.currentUrl.includes('/sign-extension')) {
      console.log('🟦 Extension entry detected via URL');

      this.isExtensionEntry = true;
      this.waitingForExt = true;

      sessionStorage.setItem('extEntry', '1');
      this.startExtensionTimeout();
      // Start warm early for extension handoff; guard inside skips guest sign-link boot.
      this.warmExtensionDetection();
    }

    // Only wait on empty page for a fresh load (extension case)
    // if (!isReload && !this.currentUrl.includes('/sign-extension')) {
    //   this.router.navigate([''], { replaceUrl: true });
    // }

     window.addEventListener('message', (event: MessageEvent) => {
      // accept only our extension message
     

      console.log("from addEventListener message ")
      if (event.data?.source === 'qrowntech_extension' && event.data?.type === 'NEW_LOCAL_PDF') {
        // --- normalize payload to always get {entry, user} ---
        if (this.extensionTimeoutRef) {
          clearTimeout(this.extensionTimeoutRef);
          this.extensionTimeoutRef = null;
        }

        this.waitingForExt = false;
        this.isExtensionEntry = false;
        sessionStorage.removeItem(this.forcedLogoutSessionKey);

        console.log('✅ Extension data received');

        const raw = event.data?.payload ?? {};
        const entry = raw?.entry ?? raw;                 // supports {entry, ...} or entry as payload
        const user = raw?.user ?? entry?.user ?? null;  // supports user in either place
        this.currentUser = user;

        console.log("entry value from addEventListener message ", entry)
        // --- guards ---
        if (!entry?.base64 || !entry?.name) {
          console.log('No file received yet.');
          return;
        }
        if (this.lastHandledDocId && this.lastHandledDocId === entry.id) return; // de-dup
        this.lastHandledDocId = entry.id;

        void (async () => {
          if (!user?.token) {
            this.zone.run(() => this.onSuccess('Extension sign-in failed. Please try again.', false));
            return;
          }
          try {
            await this.authSession.exchangeExtensionToken(user.token);
          } catch (err) {
            console.warn('Extension handoff failed:', err);
            this.zone.run(() => this.onSuccess('Extension sign-in failed. Please try again.', false));
            return;
          }

        // --- persist user (safe) ---    
        if (user) {
          try {
            if (user.language) localStorage.setItem('language', user.language);
            if (user.user_name) localStorage.setItem('user_name', user.user_name);

            const roleId = user?.role?.role_id ?? null;
            if (roleId !== null) localStorage.setItem('role', String(roleId));

            localStorage.setItem('currentUser', JSON.stringify(user));
            console.log('[LogRocket] Identifying user from Extension:');
            const loggedUserInfo = {
              id: this.currentUser?.user_name,
              name: `${this.currentUser?.first_name} ${this.currentUser?.last_name}`,
              role_id: this.currentUser?.role?.role_id,
              role_name: this.currentUser?.role?.role_name,
            };
            this.logRocketService.identify(loggedUserInfo);
            Sentry.setUser(loggedUserInfo);

            this.storageService.setUserInfo(user);
            console.log("new local storage  ", this.currentUser?.token, JSON.stringify(this.currentUser), this.currentUser?.language, String(user.role.role_id))

          } catch (e) {
            console.warn('Failed storing user info:', e);
          }
        }

        // --- stash document for target screen ---
        this.storageService.setExtensionDocumentInfo({
          document: entry.base64,
          filename: entry.name,
          user: user ?? null
        });

        // --- decide route inline (no function calls) ---
        const looksUpload =
          !!(
            user?.organization_id ||
            user?.role ||
            user?.business_sector ||
            user?.business_sector_description
          );

        console.warn('new looksUpload', looksUpload);

        const roleDescription =
          user?.role_description?.toLowerCase?.() ??
          user?.role?.role_name?.toLowerCase?.() ??
          null;

        // Signature flow has highest priority */
        const looksSignature =
          !!(
            user &&
            (
              'is_validated' in user &&
              user?.professional_title &&
              user?.status
            )
          );
        console.warn('new looksSignature', looksSignature);

        let target = '/dashboard/document-upload'; // default fallback

        if (looksSignature) {
          target = '/dashboard/digital-signature';

        } else if (roleDescription) {

          switch (roleDescription) {

            case 'admin':
            case 'test':
              target = '/dashboard/test-upload';
              break;

            case 'business':
              target = '/dashboard/document-upload';
              break;

            default:
              target = ''; // safest fallback
              break;
          }

        }
        console.warn('Resolved target route:', target);

        // this.extRouting = true;
        sessionStorage.setItem('extRouting', '1');
        sessionStorage.setItem('extTarget', target);

        console.warn('extRouting', target);

        // Upload/test-upload only: warm OCR + prefetch identifiers for faster doc-type detection.
        if (target.includes('document-upload') || target.includes('test-upload')) {
          this.warmExtensionDetection();
          this.prefetchExtensionIdentifiers();
        }

        this.getMenus()
          .then(() => this.zone.run(() => this.router.navigate([target], { replaceUrl: true })))
          .catch(err => {
            console.warn('getMenus failed, navigating anyway:', err);
            this.zone.run(() => this.router.navigate([target], { replaceUrl: true }));
          });

        this.broadcastForcedLogoutEvent();
        })();
      }
    });
  }

  /** Fire-and-forget: same warm as upload hosts, started early for extension cold start. */
  private warmExtensionDetection(): void {
    if (AuthSessionService.isGuestSignLinkBoot()) {
      return;
    }
    this.tesseractEngine.prefetch();
    this.tesseractEngine.warmDetectionPool();
  }

  /** Fire-and-forget: fill identifier cache after extension auth so detect is not API-cold. */
  private prefetchExtensionIdentifiers(): void {
    this.documentTypeDetection.getDocumentTypeIdentifiers().pipe(take(1)).subscribe({
      error: (err) => console.warn('Extension identifier prefetch failed:', err),
    });
  }

  /** Drop index.html guest boot shell when leaving sign-link before the host mounts. */
  private clearSignLinkBootShell(): void {
    if (typeof document === 'undefined') {
      return;
    }
    document.getElementById('sign-link-boot-shell')?.remove();
  }


ngAfterViewInit() {
  // Tell extension that the page is fully ready
  window.postMessage(
    {
      source: 'qrowntech_app',
      type: 'PAGE_READY'
    },
    '*'
  );
  console.log('🟢 PAGE_READY sent to extension');
}

  normalizeDate(date) {
    return new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      date.getHours(),
      date.getMinutes(),
      0, // Set seconds to 0
      0  // Set milliseconds to 0 (optional)
    );
  }

  private startExtensionTimeout() {
    this.extensionTimeoutRef = setTimeout(() => {
      if (this.waitingForExt && this.isExtensionEntry) {
        console.warn('⏰ Extension did not respond within 60 seconds');

        this.waitingForExt = false;
        this.isExtensionEntry = false;

        // safest fallback
        this.zone.run(() => {
          this.onSuccess("Something went wrong", false);
        });

      }
    }, 60000);
  }


  @HostListener('window:resize')
  onWindowResize() {
    this.getScreenWidth = window.innerWidth;
    this.getScreenHeight = window.innerHeight;
    // console.log("getScreenWidth : ", this.getScreenWidth);
  }

  private lastHandledDocId?: string; // avoid double redirects on same doc

  ngOnInit() {
    // Guest sign-link: skip second-screen tab registry (not a portal session).
    if (!AuthSessionService.isSecondScreenChild() && !AuthSessionService.isGuestSignLinkBoot()) {
      this.secondScreen.registerAppTab(this.tabId);
      window.addEventListener('pagehide', this.onPageHide);
    }
    console.log('environment', this.configService.environment);
    console.log('Api BASE_URL', this.configService.config.BASE_URL);
    var url = window.location.href;
    console.log('url',url);
    if (url.includes('/digital-signature-manual') || url.includes('/#/dashboard/digital-signature-manual')) {
      this.router.navigate(['digital-signature-manual'])
    }

    if (this.isExtensionEntry) {
    console.log('⏳ Waiting for extension (constructor listener active)');
      return;
    }
    
    this.continueNormalRouting();

  }

 onSuccess(message: string, isSuccess: boolean) {
    const diloagRef = this.dialog.open(SuccessDialogComponent, {
      data: { message: message, isSuccess: isSuccess }
    });
    diloagRef.afterClosed().subscribe((res: any) => {

    })
  }

  continueNormalRouting() {

    if (this.isExtensionEntry || this.waitingForExt) {
      console.log('⛔ (extension flow)');
      return;
    }

    window.addEventListener('storage', (event) => {
      // Guest sign-link tabs authenticate by ref/OTP, not by the shared cookie session,
      // so a logout in another tab must leave this one on the sign-link URL.
      if (AuthSessionService.isGuestSignLinkBoot()) {
        AuthSessionService.restoreSignLinkScreenId();
        return;
      }
      if (event.key === 'authSessionActive' && !event.newValue) {
        this.handleAutoLogoutFromOtherTab();
      }
      if (event.key === this.forcedLogoutEventKey && event.newValue) {
        this.handleForcedLogoutEvent(event.newValue);
      }
    });

    if (sessionStorage.getItem(this.forcedLogoutSessionKey) === '1') {
      localStorage.setItem('sessionExpiredMessage', this.labels?.token_expiry_msg || "Your session has expired. Please log in again.");
      this.secondScreen.closeManualSignatureOnSessionEnd();
      this.clearSignLinkBootShell();
      this.router.navigate(['/login']);
      return;
    }

    if (this.authSession.isForcedPasswordChange()) {
      void this.authSession.validateForcedPasswordChangeSession().then((isValid) => {
        if (!isValid) {
          this.zone.run(() => {
            this.clearSignLinkBootShell();
            this.router.navigate(['/login'], { replaceUrl: true });
          });
          return;
        }
        if (!window.location.href.includes('/#/change-password')) {
          this.zone.run(() => {
            this.clearSignLinkBootShell();
            this.router.navigate(['/change-password'], {
              queryParams: this.authSession.forcedPasswordChangeQueryParams(),
              replaceUrl: true,
            });
          });
        }
      });
      return;
    }

    // right when the component initializes, start reset state and start watching
    this.getScreenWidth = window.innerWidth;
    this.getScreenHeight = window.innerHeight;

    this.storageService.getLoginPageStatus().subscribe((isLoginPage: boolean) => {
      this.isLoginPage = isLoginPage;
    });
    const manualSignature = window.location.href.includes('/digital-signature-manual');
    const extRouting = sessionStorage.getItem('extRouting') === '1' && !manualSignature;
    console.log("//ms extension routing ", extRouting);
    if (extRouting) {
      const target = sessionStorage.getItem('extTarget') || '/dashboard/document-upload';
      if (this.router.url !== target) {
        this.getMenus()
          .finally(() => this.zone.run(() => this.router.navigate([target], { replaceUrl: true })));
      }
      return; //  prevents the rest of your dashboard/login routing from running
    }

    if (!this.isExtensionEntry) {
      this.currentUser = localStorage.getItem("currentUser") ? JSON.parse(localStorage.getItem("currentUser")) : null;
      if (this.currentUser) {
        this.storageService.setUserInfo(this.currentUser);
      }
    }
    // this.getTranslations(this.currentUser.language);
    if (this.currentUser != null) {
      console.log('[LogRocket] Identifying loggenIn User:');
      const loggedUserInfo = {
        id: this.currentUser?.user_name,
        name: `${this.currentUser?.first_name} ${this.currentUser?.last_name}`,
        role_id: this.currentUser?.role?.role_id,
        role_name: this.currentUser?.role?.role_name,
      };
      this.logRocketService.identify(loggedUserInfo);
      Sentry.setUser(loggedUserInfo);
      var url = window.location.href;
      // if (this.currentUser?.role?.role_id == 1) {
      //   this.router.navigate(['dashboard/organizations']);
      // }
      if (!window.location.href.includes('/#/change-password') && !manualSignature) {
        // if(!this.extRouting && this.extFlow){
        // console.log("!this.extRouting && this.extFlow")
        if (url.includes('/#/dashboard/upgrade')) {
          localStorage.setItem('previousURL', "/dashboard/upgrade");
        }
        if (url.includes('/#/digital-signature') || url.includes('/#/dashboard/digital-signature') || url.match(/\/#\/dashboard\/account($|\?)/)) {
          var refId = url.includes('?ref=') ? url.split('?ref=') : '';
          refId == '' ? this.router.navigate(['dashboard/digital-signature']) : this.router.navigate(['digital-signature'], { queryParams: { ref: refId[1] } })
          // }
        }
        else if (url.includes('/#/approve-page')) {
          const encodedParam = url.split('?')[1];
          console.log('Extracted Encrypted Value from cuurent user :', encodedParam);
          this.router.navigate(['approve-page'], {
            queryParams: { reference: encodedParam },
            skipLocationChange: true
          });
        }
        else if (url.includes('/#/provider')) {
          const route = url.split('#/')
          console.log("route", route);
          this.router.navigate([route[1]])
          console.log("route[1]", route[1]);
        }
        else {
          const nav = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming;
          // If this is a page refresh → DO NOT redirect
          if (nav?.type === 'reload') {
            console.log("🟦 Page refresh detected — stay on same route.");
            return;
          }

          this.router.navigate(['dashboard']);
          console.log("dash app")
        }
      }



    }
    else {
      const url = window.location.href;

      console.log("/#/approve-page ", url.includes('/#/approve-page'))

      if (url.includes('/#/approve-page')) {

        console.log("🔹 Detected approve-page route");

        if (url.includes('/approve-page?')) {
          const encodedParam = url.split('?')[1];
          console.log('Extracted Encrypted Valuef frm out login', encodedParam);


          this.router.navigate(['approve-page'], {
            queryParams: { reference: encodedParam },
            skipLocationChange: true
          });

        } else {
          console.error("⚠️ Missing required query parameters!");
        }
      }
      else {
        if (url.includes('/#/change-password') || url.includes('/#/forgot-password') || url.includes('/#/forget-password') || url.includes('/#/individual-registration') || url.includes('/#/register') || url.includes('/#/approve-page') || url.includes('/#/provider')) {
          const route = url.split('#/')

          console.log("route", route);

          this.router.navigate([route[1]])

          console.log("route[1]", route[1]);

          console.log("another #/")

        }

        else if (url.includes('/#/reset-password')) {
          var refId = url.includes('?ref=') ? url.split('?ref=') : '';
          this.router.navigate(['reset-password'], { queryParams: { ref: refId[1] } })

          console.log("this.router.navigate(['reset-password']", url, refId);

        }

        else if (url.includes('/#/digital-signature')) {
          var refId = url.includes('?ref=') ? url.split('?ref=') : '';
          this.router.navigate(['digital-signature'], { queryParams: { ref: refId[1] } })

          console.log("this.router.navigate(['digital-signature']", url, refId);

        }

        // else if ( {
        //  this.router.navigate(['provider'])
        //  }
        else {
          this.router.navigate(['login']);
          console.log("login app")

        }

      }
    }

  }
  handleAutoLogoutFromOtherTab() {
    // avoid endless loops
    if (this.router.url !== '/login') {
      this.authSession.markLoggedOut();
      this.secondScreen.closeManualSignatureOnSessionEnd();
      this.clearSignLinkBootShell();
      this.router.navigate(['/login']);
    }
  }

  private handleForcedLogoutEvent(rawEvent: string) {
    try {
      const payload = JSON.parse(rawEvent);
      if (!payload || payload.senderTabId === this.tabId) {
        return;
      }
      sessionStorage.setItem(this.forcedLogoutSessionKey, '1');
      localStorage.setItem('sessionExpiredMessage', payload.message || this.labels?.token_expiry_msg || "Your session has expired. Please log in again.");
      sessionStorage.removeItem('extRouting');
      sessionStorage.removeItem('extTarget');
      this.secondScreen.closeManualSignatureOnSessionEnd();
      this.clearSignLinkBootShell();
      this.zone.run(() => this.router.navigate(['/login']));
    } catch (error) {
      console.warn('Failed to parse forced logout event', error);
    }
  }

  private broadcastForcedLogoutEvent() {
    const payload = {
      senderTabId: this.tabId,
      timestamp: Date.now(),
      message: this.labels?.token_expiry_msg || "Your session has expired. Please log in again."
    };
    localStorage.setItem(this.forcedLogoutEventKey, JSON.stringify(payload));
  }

  private getOrCreateTabId(): string {
    const existing = sessionStorage.getItem('appTabId');
    if (existing) {
      return existing;
    }
    const generated = `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
    sessionStorage.setItem('appTabId', generated);
    return generated;
  }



  getMenus() {
    let promise = new Promise((resolve, reject) => {
      this.apiService.getMenuList().subscribe({
        next: (menuObj: any) => {
        // const menus = menuObj.list_screens.map(({ screen_id, screen_title }) => ({ screen_id, screen_title }));
        const menus = getMenuScreenIds(menuObj);
        localStorage.setItem('menuItems', menus.join(','));
        localStorage.setItem('screensPermissions', JSON.stringify(getMenuScreenList(menuObj)));

        this.isIndividualUser = menuObj.individual || false;
        localStorage.setItem('isIndividualUser', this.isIndividualUser.toString());

        // menuObj.list_screens.forEach(screen => {
        //   let value = ''
        //   Object.keys(screen).forEach((key) => {
        //     if (key.includes('permission') && screen[key] == 1) {
        //       value += key.replace('_permission', ' ');
        //     }
        //   });
          // localStorage.setItem(screen.screen_title, value);
          
          this.permissionService.loadPermissions(menuObj);

        // });
        if (this.currentUser?.role?.role_id == 1) {
          this.router.navigate(['dashboard/organizations']);
        }
        else if (this.isIndividualUser) {
          this.router.navigate(['dashboard/digital-signature']);
        }
        else {
          if (localStorage.getItem('previousURL') != null && menus.includes(1)) {

            this.router.navigate([localStorage.getItem('previousURL')]);
            localStorage.removeItem('previousURL');
          }
          else {
            this.router.navigate(["/dashboard"]);
          }
        }
        resolve(true);
      },
      error: () => {
        // Gateway/network errors are shown by SessionHttpErrorHandler.
        resolve(true);
      },
      });
    })
    return promise
  }

  private applyDocumentLanguage(language: string | null): void {
    if (typeof document === 'undefined') {
      return;
    }

    const lang = language === 'ar' ? 'ar' : language === 'fr' ? 'fr' : 'en';
    document.documentElement.lang = lang;
  }

  getTranslations(selectedLanguage: string) {
    this.apiService.getTranslationLabels(selectedLanguage).subscribe((labelsRes: any) => {
      if (labelsRes) {
        this.storageService.setLabels(labelsRes);
        this.labels = { ...this.storageService.getLabelsValue() };
        return;
      }
      const cached = this.storageService.getLabelsValue();
      if (cached) {
        this.labels = { ...cached };
      }
    });
  }

  getConfig() {
    const config = this.configService.config;
      if (config) {
        if (!AuthSessionService.isSecondScreenChild() && !AuthSessionService.isGuestSignLinkBoot()) {
          this.apiService.getCountriesWithCode().subscribe((countryObj: any) => {
            if (countryObj) {
              this.storageService.setCountries(countryObj);
            }
          });
        }
        this.SPLASH_TIMEOUT = config.SPLASH_TIMEOUT;
        this.titleService.setTitle(config.PAGE_TITLE);
        if (this.getScreenWidth > 667) {
          this.isSplashVisible = false;
        } else {
          setTimeout(() => {
            this.isSplashVisible = false;
          }, this.SPLASH_TIMEOUT)
        }
      }
  }

}
